import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/maintenance.svg'


const _withScopeId = n => (_pushScopeId("data-v-34743f09"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"flex align-items-center p-3\" data-v-34743f09><div class=\"p-2 mr-3\" data-v-34743f09><img src=\"" + _imports_0 + "\" width=\"64\" data-v-34743f09></div><div class=\"flex flex-column\" data-v-34743f09><h2 data-v-34743f09>Contrat Garantie de Service &amp; Maintenance</h2><span class=\"app-label text-default-gray font-bold\" data-v-34743f09>Un contrat personnalisé pour davantage de sérénité</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTopRightButton = _resolveComponent("CardTopRightButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "clickable pannel relative",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createVNode(_component_CardTopRightButton, { icon: "ci-arrows-back" }),
    _hoisted_1
  ]))
}